export default __webpack_public_path__ + "static/media/news-1.33ed8ef5.jpg";